import store from "@/store";
import api from "@/utils/api.util";

export class MissionService {
  static RESOURCE = "/missions/";

  static all(params = {}) {
    return api.get(this.RESOURCE, { params });
  }

  static create(data = {}) {
    return new Promise((resolve, reject) => {
      api.post(this.RESOURCE, data).then(response => {
        store.dispatch('missions/setMissionUpdated', response.data.data.id);
        return resolve(response);
      })
      .catch(err => {
        return reject(err);
      })
    })
  }

  static find(id, params = {}) {
    return api.get(this.RESOURCE + id, { params });
  }

  static update(id, data = {}) {
    return this.triggersUpdate(() => {
      return api.put(this.RESOURCE + id, data);
    }, id);
  }

  static finish(id, data = {}) {
    return this.triggersUpdate(() => {
      return api.put(this.RESOURCE + id + "/finish", data);
    }, id);
  }

  static archive(id, data = {}) {
    return this.triggersUpdate(() => {
      return api.put(this.RESOURCE + id + "/archive", data);
    }, id);
  }

  static restore(id, data = {}) {
    return this.triggersUpdate(() => {
      return api.put(this.RESOURCE + id + "/restore", data);
    }, id);
  }

  static lock(id, data = {}) {
    return this.triggersUpdate(() => {
      return api.put(this.RESOURCE + id + "/lock", data);
    }, id);
  }

  static unlock(id, data = {}) {
    const merge = { force: true };
    let input = _.isPlainObject({}) ? data : {};
    const payload = Object.assign({}, input, merge);
    return this.triggersUpdate(() => {
      return api.put(this.RESOURCE + id + "/unlock", payload);
    }, id);
  }

  static files(id, data = {}) {
    return api.get(this.RESOURCE + id + "/files", data);
  }

  static logs(id, data = {}) {
    return api.get(this.RESOURCE + id + "/logs", data);
  }

  static createFile(id, data = {}) {
    return api.post(this.RESOURCE + id + "/files", data);
  }

  static downloadFile(id, data = {}) {
    return api.get(this.RESOURCE + id + "/files/download", data);
  }

  // A method to wrap others that trigger updates so
  // that we can notify the rest of the system if
  // some kind of update to a mission occurred.
  // (the function must return axios promise)
  static triggersUpdate(fn, id) {
    return new Promise((resolve, reject) => {
      fn().then(response => {
        store.dispatch('missions/setMissionUpdated', id);
        return resolve(response);
      })
      .catch(err => {
        return reject(err);
      })
    })
  }

  static export(params = {}, options = {}) {
    return api.get(this.RESOURCE + "export", { params, ...options });
  }
}
